<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/posters?curPage=1')">1. 포스터 관리</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/feeds')">2. 피드 관리</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/clubs')">3. 후기 관리</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/events')">4. 이벤트 관리</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/util/photos')">5. 사진 업로드</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/adverts')">6. 광고 관리(메인 뷰)</span>
                                <span class="col-12 rem-2 mt-5 text-left pointer-cursor" @click="$router.push('/admin/users/invalidUniv')">7. 승인 대기중인 사용자 목록</span>
                            </v-row>
                            
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'
//import Banner from '../components/Banner.vue'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()
        //this.getPopularPoster(0)
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null

        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
        //Banner
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        }
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/Admin.vue